module.exports = __webpack_public_path__ + "img/tool-box.7c27bbaf.svg";